import formatStringByPattern from 'format-string-by-pattern'

export default function phoneInputMasking (document, moduleHTML, appEventEmitter) {
  moduleHTML.addEventListener('input', maskInputValue)

  function maskInputValue (event) {
    event.preventDefault()
    const onlyNumbers = event.target.value.replace(/[^\d]/g, '')
    event.target.value = formatPhoneNumber(onlyNumbers)
  }

  function formatPhoneNumber (phone) {
    return formatStringByPattern('999-999-9999', phone)
  }
}
